import { GridFilterOperator } from '@mui/x-data-grid'
import { buildFilterOperators } from '../helpers/buildFilterOperators'
import { SupplierSearchInputFilter } from './SupplierSearchInputFilter'

export const getSupplierSearchFilterOperators = (): GridFilterOperator[] => {
  return buildFilterOperators([
    { operators: ['equals', 'doesNotEqual'], InputComponent: SupplierSearchInputFilter },
    { operators: ['contains', 'doesNotContain'] },
  ])
}
